export type User = {
  sub: string;
  username: string;
  userId: string;
  userInfo: UserInfo;
  delegation?: Delegation[];
  role: string[];
  permissions: string[];
  iat: number;
  exp: number;
  iss: string;
  tokenType: TokenType;
};

export type Delegation = {
  netId: string;
  role: string[];
  department?: string;
  expiryDate?: string;
  createdAt?: string;
};

export type UserInfo = {
  username: string;
  netId?: string;
  displayName?: string;
  title?: string;
  department?: string;
  rightFRCDepartmentChairList?: string[];
  email?: string;
  emailAddress?: string; // tailor-made for co-supervisors
  surname?: string;
  givenName?: string;
  createdAt?: string;
  updatedAt?: string;
};
export enum TokenType {
  INTERNAL = 'INTERNAL',
  GUEST = 'GUEST',
  APPLICANT = 'APPLICANT',
}

export type Captcha = {
  questionId: string;
  submission: string;
};

export type LoginFormValues = {
  email: string;
  password: string;
  captcha?: Captcha;
};
